import { render, staticRenderFns } from "./SuratPenunjangRiwayatRekamMedis.vue?vue&type=template&id=be20cafc&"
import script from "./SuratPenunjangRiwayatRekamMedis.vue?vue&type=script&lang=js&"
export * from "./SuratPenunjangRiwayatRekamMedis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports